import { ready } from '../global/instantiate';
import blogFilters from './../components/blogFilters';
import viewMoreButton from '../sections/blogs/viewMoreBtn';
import blogPromos from '../sections/blogs/blogPromos';

ready(() => {
  blogFilters();
  viewMoreButton();
  blogPromos();
});
